import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form/immutable';
import { MenuItem, InputLabel, FormControl, Select } from '@material-ui/core';

const IncludeExcludeSelector = ({ input }) => (
  <Select value={input.value} onChange={input.onChange}>
    <MenuItem value={false}>Include</MenuItem>
    <MenuItem value>Exclude</MenuItem>
  </Select>
);
IncludeExcludeSelector.propTypes = {
  input: PropTypes.object.isRequired,
};

const FormIncludeExcludeSelector = ({ labelText, name }) => (
  <FormControl style={{ width: '100%', height: 24 }}>
    <InputLabel shrink>
      <Field name={name} component={IncludeExcludeSelector} title={labelText} />
      {` ${labelText}`}
    </InputLabel>
  </FormControl>
);
FormIncludeExcludeSelector.propTypes = {
  labelText: PropTypes.string,
  name: PropTypes.string.isRequired,
};
export default FormIncludeExcludeSelector;
